// src/components/EditDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const EditDialogBodyType = ({
  open,
  handleClose,
  type, // 'brand' or 'model'
  currentData,
  brands,
  handleSave,
}) => {
  const [name, setName] = useState('');
  const [Id, setId] = useState('');

  useEffect(() => {
  
    if (currentData) {
      setName(currentData.name || '');
      setId(currentData.id || '');
    }
  }, [currentData]);

  const onSave = () => {
    if (type === 'body') {
        if (name.trim() === '' || Id === '') {
            alert('Body Type selection cannot be empty.');
            return;
        }
        handleSave({ ...currentData, name: name.trim(), id: Id });
      }
    handleClose();
  };
    
    

  

  return (
    <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Edit {type === 'brand' ? 'Brand' : type === 'model' ? 'Model' : type === 'body' ? 'Body Type':'Unknown'}</DialogTitle>
      <DialogContent>
        <TextField
                  label={`${type === 'brand' ? 'Brand' : type === 'model' ? 'Model' : type === 'body' ? 'Body Type' : 'Unknown'} Name`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="dense"
        />
       
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          variant="contained"
          disabled={type === 'brand' ? name.trim() === '' : name.trim() === '' || Id === ''}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialogBodyType;
